import { elakay_API } from "../../config";

const authHeaders = (token) => ({
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
});

const handleResponse = (response) => response.json();
const handleError = (err) => ({
    success: false,
    error: err.message || "Une erreur inconnue est survenue"
});

// Crée une demande de mise en contact (le message réel n'est créé qu'après
// acceptation par le responsable côté serveur).
export const createContactRequest = (token, { responsibleId, topic, topicLabel, question }) => {
    return fetch(`${elakay_API}/support/contact-requests`, {
        method: "POST",
        headers: authHeaders(token),
        body: JSON.stringify({ responsibleId, topic, topicLabel, question })
    })
        .then(handleResponse)
        .catch(handleError);
};

export const listMyContactRequests = (token) => {
    return fetch(`${elakay_API}/support/contact-requests/mine`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const listIncomingContactRequests = (token, status) => {
    const query = status ? `?status=${encodeURIComponent(status)}` : "";
    return fetch(`${elakay_API}/support/contact-requests/incoming${query}`, {
        method: "GET",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const acceptContactRequest = (token, requestId) => {
    return fetch(`${elakay_API}/support/contact-requests/${requestId}/accept`, {
        method: "PATCH",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};

export const declineContactRequest = (token, requestId) => {
    return fetch(`${elakay_API}/support/contact-requests/${requestId}/decline`, {
        method: "PATCH",
        headers: authHeaders(token)
    })
        .then(handleResponse)
        .catch(handleError);
};
